import BybButtonChip from "@Components/common/byb-ds/buttons/byb-button-chip";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import Icon from "@Components/generic/icon";
import { faThumbsDown, faThumbsUp } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { IconButton, Stack, Typography, useTheme } from "@mui/material";

export type UserRating = "up" | "down" | null;

interface IFeedbackHeader {
  onLearnMoreClick: () => void;
  onRate: (rating: "up" | "down") => void;
  userRating: UserRating;
}

const FeedbackHeader = ({ onLearnMoreClick, onRate, userRating }: IFeedbackHeader) => {
  const { i18n } = useI18n();
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Typography variant="text1xl700" color="dsBase.v200">
          {i18n("session-results.decision-insights")}
        </Typography>
        <BybButtonChip
          onClick={onLearnMoreClick}
          sx={{
            backgroundColor: `${theme.palette.dsWarning.v400}15`,
            borderRadius: 10,
            padding: theme.spacing(1, 2),
            "& .MuiTypography-root": {
              color: "dsWarning.v400",
              fontWeight: 500,
            },
            ":hover": {
              backgroundColor: `${theme.palette.dsWarning.v400}25`,
            },
          }}
        >
          {i18n("session-results.beta.learn-more")}
        </BybButtonChip>
      </Stack>

      <Stack direction="row" spacing={1}>
        <HapticsButtonWrapper>
          <IconButton
            onClick={() => onRate("up")}
            sx={{
              backgroundColor: userRating === "up" ? `${theme.palette.dsSuccess.v300}20` : "dsSurface.v300",
              color: userRating === "up" ? "dsSuccess.v300" : "dsNeutral.v300",
              "&:hover": {
                backgroundColor: `${theme.palette.dsSuccess.v300}30`,
              },
            }}
          >
            <Icon icon={faThumbsUp} size="sm" />
          </IconButton>
        </HapticsButtonWrapper>
        <HapticsButtonWrapper>
          <IconButton
            onClick={() => onRate("down")}
            sx={{
              backgroundColor: userRating === "down" ? `${theme.palette.dsDestructive.v300}20` : "dsSurface.v300",
              color: userRating === "down" ? "dsDestructive.v300" : "dsNeutral.v300",
              "&:hover": {
                backgroundColor: `${theme.palette.dsDestructive.v300}30`,
              },
            }}
          >
            <Icon icon={faThumbsDown} size="sm" />
          </IconButton>
        </HapticsButtonWrapper>
      </Stack>
    </Stack>
  );
};

export default FeedbackHeader;
